import React from 'react';
import { Form, InputNumber, Input } from 'antd';

export const MemberSalaryTab: React.FC = () => {
    return (
        <div className="form-section">
            <Form.Item name="social_security_base" label="社保基数">
                <InputNumber style={{ width: '100%' }} min={0} precision={2} addonAfter="元" />
            </Form.Item>

            <Form.Item name="housing_fund_base" label="公积金基数">
                <InputNumber style={{ width: '100%' }} min={0} precision={2} addonAfter="元" />
            </Form.Item>

            <Form.Item name="bank_account" label="工资卡号">
                <Input placeholder="银行卡号" />
            </Form.Item>

            <Form.Item name="bank_name" label="开户行">
                <Input placeholder="如：中国工商银行深圳分行" />
            </Form.Item>
        </div>
    );
};
